// Client des commandes de gros, inventaires, PA et réglages Provider
// (mêmes conventions que providerProductService : JSON clair, jamais de throw).
import { elakay_API } from "../../../config";
import { ROUTE_PREFIX } from "../constants/dropshippingInterneConstants";

const BASE = `${elakay_API}${ROUTE_PREFIX}`;

export const dsApi = async (token, method, path, body) => {
  try {
    const response = await fetch(`${BASE}${path}`, {
      method,
      headers: { "Content-Type": "application/json", ...(token && { Authorization: `Bearer ${token}` }) },
      ...(body !== undefined && { body: JSON.stringify(body) }),
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) return { success: false, status: response.status, ...data, error: data.error || "Network or server error." };
    return data;
  } catch (error) {
    return { success: false, error: error.message };
  }
};
const qs = (params = {}) => {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => v !== undefined && v !== "" && v !== null && q.set(k, v));
  const s = q.toString();
  return s ? `?${s}` : "";
};

export const quoteWholesaleCart = (t, items, deliveryOption) => dsApi(t, "POST", "/seller/wholesale/quote", { items, deliveryOption });
export const placeWholesaleOrder = (t, payload) => dsApi(t, "POST", "/seller/wholesale/orders", payload);
export const listSellerOrders = (t, params) => dsApi(t, "GET", `/seller/wholesale/orders${qs(params)}`);
export const cancelSellerOrder = (t, id) => dsApi(t, "POST", `/seller/wholesale/orders/${id}/cancel`, {});
export const getSellerInventory = (t) => dsApi(t, "GET", "/seller/inventory");
export const listProviderPlansForSeller = (t, providerId) => dsApi(t, "GET", `/seller/pa/providers/${providerId}/plans`);
export const listSellerSubscriptions = (t) => dsApi(t, "GET", "/seller/pa/subscriptions");
export const subscribeToPlan = (t, planId) => dsApi(t, "POST", "/seller/pa/subscriptions", { planId });
export const cancelSubscription = (t, id) => dsApi(t, "POST", `/seller/pa/subscriptions/${id}/cancel`, {});

export const listProviderOrders = (t, params) => dsApi(t, "GET", `/provider/wholesale/orders${qs(params)}`);
// Operational projections of marketplace order items; these never create a wholesale purchase.
export const listCustomerOrders = (t, side, params) => dsApi(t, "GET", `/${side === "provider" ? "provider" : "seller"}/customer-orders${qs(params)}`);
export const customerOrderAction = (t, side, orderId, orderItemId, action, body = {}) => dsApi(t, "POST", `/${side === "provider" ? "provider" : "seller"}/customer-orders/${encodeURIComponent(orderId)}/items/${encodeURIComponent(orderItemId)}/${encodeURIComponent(action)}`, body);
export const providerOrderAction = (t, id, action, body = {}) => dsApi(t, "POST", `/provider/wholesale/orders/${id}/${action}`, body);
export const providerMarkPaid = (t, id) => dsApi(t, "POST", `/provider/wholesale/orders/${id}/mark-paid`, {});
export const getProviderInventory = (t, params) => dsApi(t, "GET", `/provider/inventory${qs(params)}`);
export const listOwnPlans = (t) => dsApi(t, "GET", "/provider/pa/plans");
export const createPlan = (t, plan) => dsApi(t, "POST", "/provider/pa/plans", plan);
export const updatePlan = (t, id, plan) => dsApi(t, "PATCH", `/provider/pa/plans/${id}`, plan);
export const deletePlan = (t, id) => dsApi(t, "DELETE", `/provider/pa/plans/${id}`);
export const listSubscribers = (t, status) => dsApi(t, "GET", `/provider/pa/subscribers${qs({ status })}`);
export const decideSubscription = (t, id, action) => dsApi(t, "POST", `/provider/pa/subscriptions/${id}/${action}`, {});
export const getProviderSettings = (t) => dsApi(t, "GET", "/provider/settings");
export const saveProviderSettings = (t, settings) => dsApi(t, "PUT", "/provider/settings", settings);
export const confirmOrderReceipt = (t, id) => dsApi(t, "POST", `/seller/wholesale/orders/${id}/confirm-receipt`, {});
export const simulateSellerProduct = (t, providerProductId, body) => dsApi(t, "POST", `/seller/products/${providerProductId}/simulate`, body);
export const changeLinkFulfillment = (t, linkId, fulfillmentMode) => dsApi(t, "PATCH", `/seller/links/${linkId}/fulfillment`, { fulfillmentMode });
